import {
  ACTION_LABELS,
  MODULE_TRANSITION_ACTIONS,
  type BaseState,
  type StatusModule,
  type StatusTone,
  type TransitionAction,
} from "@cx/domain";

/** Nome da cor (tom do StatusBadge) em pt-BR. */
export const TONE_LABELS: Readonly<Record<StatusTone, string>> = {
  info: "Azul",
  warning: "Amarelo",
  success: "Verde",
  danger: "Vermelho",
  secondary: "Cinza",
};

/** Ações da transição em texto, na ordem do catálogo; vazia = "Só muda a situação". */
export function describeActions(actions: readonly TransitionAction[]): string {
  return actions.length ? actions.map((a) => ACTION_LABELS[a]).join(", ") : "Só muda a situação";
}

const FORWARD: ReadonlySet<TransitionAction> = new Set(["reserve_stock", "post_stock", "post_financial"]);

/**
 * Ações oferecidas no diálogo: as do módulo; para destino cancelado, só os estornos (o motor já estorna tudo ao
 * cancelar, então são informativas).
 */
export function offeredActions(module: StatusModule, targetBase: BaseState | null): TransitionAction[] {
  const all = MODULE_TRANSITION_ACTIONS[module];
  return targetBase === "canceled" ? all.filter((a) => !FORWARD.has(a)) : [...all];
}
